import { toast } from "vue-sonner";

const isSuperAdminState = () => useState<boolean | null>("is-super-admin", () => null);

export default defineNuxtRouteMiddleware(async (to) => {
    if (!to.path.startsWith("/admin")) {
        return;
    }

    const user = await useSupabaseUserSync();

    if (!user) {
        if (import.meta.client) {
            toast.error("Please sign in to continue");
        }

        return navigateTo("/login");
    }

    const isSuperAdmin = isSuperAdminState();

    if (isSuperAdmin.value === true) {
        return;
    }

    if (isSuperAdmin.value === false) {
        if (import.meta.client) {
            toast.error("You do not have access to the global admin area");
        }
        return navigateTo("/");
    }

    const supabase = useSupabaseClient();
    const { data, error } = await supabase.rpc("is_super_user");

    if (error) {
        console.error(error);
        if (import.meta.client) {
            toast.error("Failed to check admin status", {description: humanizeError(error)});
        }
        isSuperAdmin.value = false;
        return navigateTo("/");
    }

    const canAccess = Boolean(data);
    isSuperAdmin.value = canAccess;

    if (!canAccess) {
        if (import.meta.client) {
            toast.error("You do not have access to the global admin area");
        }
        return navigateTo("/");
    }
});
